module.exports = __webpack_public_path__ + "static/media/tommySleeve1.f13bdc08.svg";